import { apiClient } from '@/app/core/services/apiClient.service';
import { BaseApiService } from '@/app/shared/services/apis/baseApi.service';

class UserApiService extends BaseApiService {
    getUserData() {
        return this.client.get('users/me');
    }
    getEventsRoles() {
        return this.client.get(`users/me/event-roles`);
    }
    getUserRoleByPIN(payload) {
        return this.client.post(`users/role-by-pin`, payload);
    }
    getUserMainEventRoleByQRCode(payload) {
        return this.client.post(`users/role-by-qr-code`, payload);
    }
}
export const userApi = new UserApiService(apiClient);
